window.Aj = function () {
    this.url = "";
    this.dati = new Array();
    this.async = true;
    this.arrayToJson = false;
    this.abortAjax = false;

    this.add_mod_data = function (name, value) {
        this.dati[name] = value;
    };
    this.add_mod_data_array = function (data_array) {
        this.dati = mergeArray(data_array, this.dati);
    };
    this.add_mod_data_serializeArray = function (data_array) {
        this.insert_serializeArray(data_array);
    };

    this.add_form_data = function (id_form) {
        var form = $(id_form),
            formParams = form.serializeArray();
        this.insert_serializeArray(formParams);
        var array2 = new Array();

        $.each(form.find('input[type="file"]'), function (i, tag) {
            $.each($(tag)[0].files, function (i, file) {
                //array2[tag.name] = file;
                var multipleItem = tag.name.indexOf("[]");
                if (multipleItem >= 0 && multipleItem == (tag.name.length - 2)) {
                    array2[tag.name] = array2[tag.name] || [];
                    array2[tag.name].push(file);
                } else {
                    array2[tag.name] = file;
                }

            });
        });

        this.dati = mergeArray(array2, this.dati);
    };

    this.add_div_data = function ($elem) {
        var formParams = this.serializeDiv($elem, "serializeArray");
        this.insert_serializeArray(formParams);
        var array2 = new Array();

        $.each($elem.find('input[type="file"]'), function (i, tag) {
            $.each($(tag)[0].files, function (i, file) {
                //array2[tag.name] = file;
                var multipleItem = tag.name.indexOf("[]");
                if (multipleItem >= 0 && multipleItem == (tag.name.length - 2)) {
                    array2[tag.name] = array2[tag.name] || [];
                    array2[tag.name].push(file);
                } else {
                    array2[tag.name] = file;
                }

            });
        });

        this.dati = mergeArray(array2, this.dati);
    };

    this.insert_serializeArray = function (formParams) {
        var array2 = new Array();
        $.each(formParams, function (i, field) {
            var multipleItem = field.name.indexOf("[]");
            if (multipleItem >= 0 && multipleItem == (field.name.length - 2)) {
                array2[field.name] = array2[field.name] || [];
                array2[field.name].push(field.value);
            } else {
                array2[field.name] = field.value;
            }
        });

        this.dati = mergeArray(array2, this.dati);
    }

    this.serializeDiv = function ($div, serialize_method) {
        // Accepts 'serialize', 'serializeArray'; Implicit 'serialize'
        serialize_method = serialize_method || 'serialize';

        // Unique selector for wrapper forms
        var inner_wrapper_class = 'custom_form';

        // Wrap content with a form
        $div.wrapInner("<form class='" + inner_wrapper_class + "'></form>");

        // Serialize inputs
        var result = $('.' + inner_wrapper_class, $div)[serialize_method]();

        // Eliminate newly created form
        $('.custom_form', $div).contents().unwrap();

        // Return result
        return result;
    }

    this.get_data = function (name) {
        return this.dati[name];
    };

    this.remove_data = function (name) {
        delete this.dati[name];
    };
    this.remove_all_data = function () {
        for (var k in this.dati) {
            delete this.dati[k];
        }
    }
    this.fillForm = function () {
        var a = this.dati;
        for (var k in a) {
            if ($('[name="' + k + '"]').length > 0) {
                var tipo = "txt";
                if ($('[name="' + k + '"]').is('select')) {
                    tipo = "select";
                }
                if ($('[name="' + k + '"]').attr('type') == "radio") {
                    tipo = "radio";
                }
                if ($('[name="' + k + '"]').attr('type') == "checkbox") {
                    tipo = "checkbox";
                }
                switch (tipo) {
                    case "select":
                        if ($.isArray(a[k])) {
                            for (var i in a[k]) {
                                $('[name="' + k + '"] option[value="' + a[k][i] + '"]').attr('selected', 'selected');
                            }
                        } else {
                            $('[name="' + k + '"] option[value="' + a[k] + '"]').attr('selected', 'selected');
                        }
                        break;
                    case "radio":
                        $('[name="' + k + '"][value="' + a[k] + '"]').attr('checked', 'checked');
                        break;
                    case "checkbox":
                        $('[name="' + k + '"][value="' + a[k] + '"]').attr('checked', 'checked');
                        break;
                    case "txt":
                        $('[name="' + k + '"]').val(a[k]);
                        break;
                }

            }

        }
    }
    this.get_serialize = function () {
        var datastring = "";
        if (typeof csrf !== 'undefined' && csrf !== null) {
            this.add_mod_data(csrf.name, csrf.hash);
        }
        for (var k in this.dati) {
            if ($.isArray(this.dati[k])) {
                if (this.arrayToJson) {
                    var kempty = k.substr(0, k.indexOf("[]"));
                    datastring += kempty + "=" + JSON.stringify(this.dati[k]) + "&";
                } else {
                    for (var j in this.dati[k]) {
                        datastring += k + "=" + this.dati[k][j] + "&";
                    }
                }

            } else {
                datastring += k + "=" + this.dati[k] + "&";
            }

        }
        datastring = datastring.replace(/&*$/, '');
        return datastring;
    }

    this.get_serialize_file = function () {
        var formData = new FormData();
        for (var k in this.dati) {
            if ($.isArray(this.dati[k])) {

                if (this.arrayToJson) {
                    var kempty = k.substr(0, k.indexOf("[]"));
                    formData.append(kempty, JSON.stringify(this.dati[k]));
                    //datastring += kempty + "=" + JSON.stringify(this.dati[k]) + "&";
                } else {
                    for (var j in this.dati[k]) {
                        formData.append(k, this.dati[k][j]);
                        //datastring += k + "=" + this.dati[k][j] + "&";
                    }
                }

            } else {
                formData.append(k, this.dati[k]);
                //datastring += k + "=" + this.dati[k] + "&";
            }

        }

        return formData;
    }

    this.send_ajax = function (method, get_type, callbacksucces, callbackerror) {
        if (this.abortAjax) {
            $.ajaxQ.abortAll();
        }
        var currentRequest = null;
        currentRequest = $.ajax({
            url: this.url,
            async: this.async,
            type: method,
            dataType: get_type,
            cache: false,
            xhrFields: {
                withCredentials: true
            },
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            crossDomain: true,
            data: this.get_serialize(),
            beforeSend: function () {
                if (currentRequest != null) {
                    currentRequest.abort();
                }
            },
            success: function (response) {
                if (response.code == 403) {
                    location.href = '/admin';
                } else {
                    callbacksucces(response);
                }
            },
            error: function (XMLHttpRequest, textStatus, errorThrown) {
                if (callbackerror === undefined) {
                    response = "err--" + XMLHttpRequest.status + " -- " + XMLHttpRequest.statusText;
                    alert(response);
                } else {
                    if (textStatus != "abort") {
                        callbackerror(XMLHttpRequest, textStatus, errorThrown);
                    }
                }

            }
        });
    }

    this.send_ajax_static = function (data, method, get_type, callbacksucces, callbackerror) {
        $.ajaxQ.abortAll();
        var currentRequest = null;
        currentRequest = $.ajax({
            url: this.url,
            type: method,
            dataType: get_type,
            data: data,
            enctype: 'multipart/form-data',
            processData: false,  // tell jQuery not to process the data
            contentType: false,   // tell jQuery not to set contentType
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            beforeSend: function () {
                if (currentRequest != null) {
                    currentRequest.abort();
                }
            },
            success: function (response, textStatus, jqXHR) {
                if (response.code == 403) {
                    location.href = '/admin';
                } else {
                    callbacksucces(response);
                }
            },
            error: function (XMLHttpRequest, textStatus, errorThrown) {
                if (callbackerror === undefined) {
                    response = "err--" + XMLHttpRequest.status + " -- " + XMLHttpRequest.statusText;
                    alert(response);
                } else {
                    callbacksucces(XMLHttpRequest, textStatus, errorThrown);
                }

            }
        });
    }

    this.send_ajax_file = function (method, get_type, callbacksucces, callbackerror) {
        if (this.abortAjax) {
            $.ajaxQ.abortAll();
        }
        var currentRequest = null;
        var data = this.get_serialize_file();
        currentRequest = $.ajax({
            url: this.url,
            async: this.async,
            type: method,
            dataType: get_type,
            data: data,
            enctype: 'multipart/form-data',
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            xhrFields: {
                withCredentials: true
            },
            beforeSend: function () {
                if (currentRequest != null) {
                    currentRequest.abort();
                }
            },
            success: function (response) {
                if (response.code == 403) {
                    location.href = '/admin';
                } else {
                    callbacksucces(response);
                }
            },
            error: function (XMLHttpRequest, textStatus, errorThrown) {
                if (callbackerror === undefined) {
                    response = "err--" + XMLHttpRequest.status + " -- " + XMLHttpRequest.statusText;
                    alert(response);
                } else {
                    if (textStatus != "abort") {
                        callbackerror(XMLHttpRequest, textStatus, errorThrown);
                    }
                }

            }
        });
    }

    var mergeArray = function (array1, array2) {
        for (item in array1) {
            if (typeof array1[item] === 'object' && array1[item].constructor.name != "File") {
                if (array1[item].length > 0) {
                    if (array1[item][0].constructor.name == "File") {
                        array2[item] = array1[item];
                        continue;
                    }
                }
                //array2[item] = JSON.stringify(array1[item]);
                array2[item] = array1[item];
            } else {
                array2[item] = array1[item];
            }

        }
        return array2;
    }
}

$.ajaxQ = (function () {
    var id = 0,
        Q = {};

    $(document).ajaxSend(function (e, jqx) {
        jqx._id = ++id;
        Q[jqx._id] = jqx;
    });
    $(document).ajaxComplete(function (e, jqx) {
        delete Q[jqx._id];
    });

    return {
        abortAll: function () {
            var r = [];
            $.each(Q, function (i, jqx) {
                r.push(jqx._id);
                jqx.abort();
            });
            return r;
        }
    };

})();
